import { CommandBar } from '@fluentui/react';
import { DefaultButton, MessageBarButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Callout, DirectionalHint } from '@fluentui/react/lib/Callout';
import { ComboBox, IComboBoxOption } from '@fluentui/react/lib/ComboBox';
import { ContextualMenu } from '@fluentui/react/lib/ContextualMenu';
import { ConstrainMode, DetailsList, DetailsListLayoutMode, IColumn, Selection, SelectionMode } from '@fluentui/react/lib/DetailsList';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { Dropdown, IDropdownOption } from "@fluentui/react/lib/Dropdown";
import { Icon } from '@fluentui/react/lib/Icon';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { Label } from '@fluentui/react/lib/Label';
import { Link } from "@fluentui/react/lib/Link";
import { MessageBar, MessageBarType } from '@fluentui/react/lib/MessageBar';
import { ISuggestionItemProps, ITag, TagPicker } from '@fluentui/react/lib/Pickers';
import { Separator } from '@fluentui/react/lib/Separator';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import { IStackTokens, Stack, StackItem } from "@fluentui/react/lib/Stack";
import { ITextProps, Text } from '@fluentui/react/lib/Text';
import { TextField } from "@fluentui/react/lib/TextField";
import { getFocusStyle, getTheme, mergeStyleSets } from "@fluentui/style-utilities";
import * as $ from 'jquery';
import 'jquery-mask-plugin';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { CommonModels } from "../models/CommonModels";
import { EventBus, Registry } from '../utilities/EventBus';
import authService from './api-authorization/AuthorizeService';

initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/');

const theme = getTheme();
const { palette, semanticColors, fonts } = theme;
const classNames = mergeStyleSets({
    itemCell: [
        getFocusStyle(theme, { inset: -1 }),
        {
            minHeight: 54,
            padding: 10,
            boxSizing: 'border-box',
            borderBottom: `1px solid ${semanticColors.bodyDivider}`,
            display: 'flex',
            selectors: {
                '&:hover': { background: palette.neutralLight },
            },
        },
    ],
    itemContent: {
        marginLeft: 10,
        overflow: 'hidden',
        flexGrow: 1,
        textAlign: "left"
    },
    itemName: [
        fonts.medium,
        {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    ],
    chevron: {
        alignSelf: 'center',
        marginLeft: 10,
        color: palette.neutralTertiary,
        fontSize: fonts.large.fontSize,
        flexShrink: 0,
    },
});
const wrapTokens: IStackTokens = { childrenGap: 15 };

let eventListener: Registry;
let token;

let invalid: Array<CommonModels.KeyValuePair> = [];
let required: Array<CommonModels.KeyValuePair> = [
    { key: "pt_noticeemployer", value: "Referring Employer/Agency - Name is required" },
    { key: "pt_noticeemployeraddressline1", value: "Referring Employer/Agency - Address line 1 is required" },
    { key: "pt_noticeemployercity", value: "Referring Employer/Agency - City is required" },
    { key: "pt_noticeemployerstate", value: "Referring Employer/Agency - State is required" },
    { key: "pt_noticeemployerzip", value: "Referring Employer/Agency - Zip is required" },
    { key: "pt_nemployercontactfirstname", value: "Agency Contact - First name is required" },
    { key: "pt_nemployercontactlastname", value: "Agency Contact - Last name is required" },
    { key: "pt_noticeemployerphone", value: "Agency Contact - Phone is required" },
    { key: "pt_noticeemployeremail", value: "Agency Contact - Business Email is required" },
    { key: "pt_noticenegotiationstate", value: "Location of Requested Service - State is required" },
    { key: "pt_noticenegotiationzip", value: "Location of Requested Service - Zip is required" },
    { key: "pt_nhowtomeet", value: "How would you like to meet? is required" },
];

const _columns = [
    { key: 'createdOn', name: 'Date Submitted', fieldName: 'createdOn', isResizable: true, minWidth: 100 },
    { key: 'pt_ConfirmationNoticeNumber', name: 'Confirmation #', fieldName: 'pt_ConfirmationNoticeNumber', isResizable: true, minWidth: 100 },
    { key: 'pt_NContractNumber', name: 'Contract Number', fieldName: 'pt_NContractNumber', isResizable: true, minWidth: 100 },
    { key: 'pt_NoticeEmployer', name: 'Employer', fieldName: 'pt_NoticeEmployer', isResizable: true, minWidth: 200 },
    { key: 'pt_NoticeUnionContact', name: 'Individual', fieldName: 'pt_NoticeUnionContact', isResizable: true, minWidth: 200 },
    { key: 'pt_NBasisForComplaint', name: 'Basis for Complaint', fieldName: 'pt_NBasisForComplaint', isResizable: true, minWidth: 100 },
    { key: 'view', name: 'View', fieldName: 'value', isResizable: true, minWidth: 100 },
];

const _documentColumns = [
    { key: 'pt_DocumentName', name: 'Document Name', fieldName: 'pt_DocumentName', isResizable: true, minWidth: 150 },
    { key: 'pt_DocumentType', name: 'Document Type', fieldName: 'pt_DocumentType', isResizable: true, minWidth: 500 },
    //{ key: 'pt_DocumentTypeId', name: 'Document Type Id', fieldName: 'pt_DocumentTypeId', isResizable: true, visible: false },
];

const styles = mergeStyleSets({
    documentStyles: {
        'border-style': 'solid',
        'border-width': '1px',
        'margin-right': '5px',
        'height': '32px'
    }
});

//Temporary
const options: IComboBoxOption[] = [
    { key: 'A', text: 'Place Holder 1' },
    { key: 'B', text: 'Place Holder 2' }
];

enum zipValidationStatusOptions { ValidZip = 692220003, InvalidZip = 692220001, MissinginCRM = 692220000 };

const addressColumns = [
    { key: 'address', name: '', fieldName: 'freeformAddress', minWidth: 250, isResizable: true }
];

let selectedDocument;

interface ReferralControlState {
    formState: CommonModels.FormState,
    redirect: boolean,
    formSubmitted: boolean,
    complaints: Array<CommonModels.KeyValuePair>,
    states: Array<CommonModels.State>,
    user?: any,
    referrals?: Array<any>,
    dismissClonePrompt: boolean,
    cloneModalHidden: boolean,
    cloneModalLoading: boolean,
    uploadDocumentModalHidden: boolean,
    documentSelectionCount: number,
    selectionCount: number,
    selection: Array<any>,
    documentSelection: Array<any>,
    attachment?: any,
    errorMessages: [],
    requiredBasisForComplaint: boolean,
    requiredComplainant: boolean,
    referralrecord?: any,
    unionAddressSame: boolean,
    dialogHidden: boolean,
    dialogResetHidden: boolean,
    pt_noticeemployerstate_selectedItems: Array<ITag>,
    pt_noticenegotiationstate_selectedItems: Array<ITag>,
    pt_ncounselrepphone?: string,
    pt_ncounselrepphoneext?: string,
    pt_ncounselrepemail?: string,
    pt_ncounselrepemail_confirm?: string,
    pt_ncounselrepfax?: string,
    pt_nbasisforcomplaint?: string,
    pt_noticeemployer?: string,
    pt_nbureau?: string,
    pt_noffice?: string,
    pt_noticeemployeraddressline1?: string,
    pt_noticeemployeraddressline2?: string,
    pt_noticeemployercity?: string,
    pt_noticeemployerstate?: string,
    pt_noticeemployerzip?: string,
    pt_nemployercontactfirstname?: string,
    pt_nemployercontactlastname?: string,
    pt_noticeemployerphone?: string,
    pt_nemployerphoneext?: string,
    pt_noticeemployeremail?: string,
    pt_noticeemployeremail_confirm?: string,
    pt_noticeunioncontact?: string,
    pt_nunioncontactfirstname?: string,
    pt_nunioncontactlastname?: string,
    pt_nadditionalcomplainants?: string,
    pt_noticeunionphone?: string,
    pt_ncomplainantphoneext?: string,
    pt_noticeunionemail?: string,
    pt_noticeunionemail_confirm?: string,
    pt_nfilerfirstname?: string,
    pt_nfilerlastname?: string,
    pt_nfilertitle?: string,
    pt_nfileremail?: string,
    pt_nfilerphone?: string,
    pt_nfilerphoneext?: string,
    pt_noticecasetype?: string,
    pt_notices: number,
    pt_nagencyreference?: string,
    pt_noticenegotiationcity?: string,
    pt_noticenegotiationstate?: string,
    pt_noticenegotiationzip?: string,
    pt_ncounselrep?: string,
    pt_ncounselrepfirstname?: string,
    pt_ncounselreplastname?: string,
    pt_nrespondentname?: string,
    pt_nrespondentcontact?: string,
    pt_nrespondentcontactfirstname?: string,
    pt_nrespondentcontactlastname?: string,
    pt_nrespondentphone?: string,
    pt_nrespondentext?: string,
    pt_nrespondentemail?: string,
    pt_nrespondentemail_confirm?: string,
    pt_nremarks?: string,
    pt_nreceiveddate: Date,
    pt_receiveddate: Date,
    pt_reopenerdate?: Date,
    pt_f7noticesubmissionformat: number,
    filterYear: number,
    referralFilter: number,
    userFilters: Array<CommonModels.Filter>,
    filters: Array<CommonModels.KeyValuePair>,
    addressSearchMinLength: number,
    azMapsKey: string,
    addresssGeocodeServiceUrlTemplate: string,
    azMapsLanguage: string,
    azMapsCoutrySet: string,
    searchAddresses: Array<CommonModels.searchAddress>,
    eCalloutVisible: boolean,
    isLoaded: boolean,
    controlCallback?: (newValue: any) => void,
    employerAddressSearchId: string,
    pt_headertitle?: string,
    pt_header?: string,
    pt_footertitle?: string,
    pt_footer?: string,
    referralFormat: number,
    howToMeets: Array<CommonModels.KeyValuePair>,
    documentTypes: Array<CommonModels.KeyValuePair>,
    pt_documenttypeId: string,
    pt_documenttype: string,
    pt_nhowtomeet?: string,
    mediators: Array<CommonModels.Mediator>,
    pt_nrequestpreferredmediator_selectedItems: Array<ITag>,
    pt_nrequestpreferredmediator: string,
    additionalEmail1?: string,
    additionalEmail2?: string,
    additionalEmail3?: string,
    additionalEmail4?: string,
    additionalEmail5?: string,
    additionalEmail6?: string,
    additionalEmail7?: string,
    additionalEmail8?: string,
    additionalEmail9?: string,
    additionalEmails: Array<CommonModels.CaseAdditionalEmail>,
    additionalEmailsCopy: Array<any>,
    pt_negotiationzipvalidationstatus: number,
    documents: Array<any>,
    enableFileUploadOKButton: boolean,
    tempAttachment?: any,
    documentRequired?: string,
    documentTypeRequired?: string,
    invalidFileUpload?: string,
}

export default class ReferralSubmission extends React.Component<ReferralControlState> {
    _eSelection = new Selection({
        onSelectionChanged: () => this.setEmpAddressSelectedValue(this._eSelection.getSelection()),
    });

    state: ReferralControlState = {
        formState: CommonModels.FormState.OnLoad,
        dismissClonePrompt: false,
        cloneModalHidden: true,
        cloneModalLoading: false,
        uploadDocumentModalHidden: true,
        selectionCount: 0,
        documentSelectionCount: 0,
        selection: [],
        documentSelection: [],
        redirect: false,
        formSubmitted: false,
        complaints: [],
        states: [],
        errorMessages: [],
        pt_noticeemployerstate_selectedItems: [],
        pt_noticenegotiationstate_selectedItems: [],
        requiredBasisForComplaint: false,
        requiredComplainant: false,
        unionAddressSame: false,
        dialogHidden: true,
        dialogResetHidden: true,
        pt_notices: 1,
        pt_nreceiveddate: new Date(),
        pt_receiveddate: new Date(),
        pt_f7noticesubmissionformat: 206300004,
        filterYear: 25,
        referralFilter: 25,
        userFilters: [],
        filters: [],
        addressSearchMinLength: 3,
        azMapsKey: 'EIBAsug5HXjYKUTGdubbqIxC7fR-lD9gg4k4HDDKLec',
        azMapsLanguage: 'en-US',
        azMapsCoutrySet: 'US',
        addresssGeocodeServiceUrlTemplate: 'https://atlas.microsoft.com/search/address/json?typeahead=true&api-version=1&subscription-key={key}&query={query}&language={language}&countrySet={countrySet}&view=Auto',
        searchAddresses: [],
        eCalloutVisible: false,
        isLoaded: false,
        employerAddressSearchId: 'pt_noticeemployeraddressline1',
        pt_headertitle: null,
        pt_header: null,
        pt_footertitle: null,
        pt_footer: null,
        referralFormat: 692220001,
        howToMeets: [],
        documentTypes: [],
        pt_documenttypeId: null,
        pt_documenttype: null,
        pt_nhowtomeet: null,
        mediators: [],
        pt_nrequestpreferredmediator_selectedItems: [],
        pt_nrequestpreferredmediator: null,
        additionalEmail1: null,
        additionalEmail2: null,
        additionalEmail3: null,
        additionalEmail4: null,
        additionalEmail5: null,
        additionalEmail6: null,
        additionalEmail7: null,
        additionalEmail8: null,
        additionalEmail9: null,
        additionalEmails: [],
        additionalEmailsCopy: [],
        pt_negotiationzipvalidationstatus: zipValidationStatusOptions.InvalidZip,
        documents: [],
        enableFileUploadOKButton: false,
        documentRequired: null,
        documentTypeRequired: null,
        invalidFileUpload: null
    }

    public componentDidMount() {
        console.log("componentDidMount");
        $('input[alt=zipmask]').mask('00000-0000', {
            placeholder: 'Enter 5 or 9 digit zip code'
        });
        $('input[alt=phonemask]').mask('(000) 000-0000', {
            placeholder: '(000) 000-0000'
        });

        eventListener = EventBus.getInstance().register('ReferralSubmission', (name: string) => {
            switch (name) {
                case "ResetFormData":
                    if (this.state.formState == CommonModels.FormState.SaveComplete) {
                        this.resetFormData();
                    }
                    else {
                        this.setState({ dialogResetHidden: false });
                    }
                    break;
            }
        });

        fetch('states')
            .then(response => response.json())
            .then(dataStates => this.setState({ states: dataStates }));
        fetch('sector')
            .then(response => response.json())
            .then(dataSectors => this.setState({ sectors: dataSectors, pt_nsector: dataSectors.filter(function (v: any, i: any) { return v.value == "Federal Sector" })[0].key, pt_sector: dataSectors.filter(function (v: any, i: any) { return v.value == "Federal Sector" })[0].key }));
        fetch('complaints')
            .then(response => response.json())
            .then(dataComplaints => this.setState({ complaints: dataComplaints }));
        fetch('mediator')
            .then(response => response.json())
            .then(dataMediators => this.setState({ mediators: dataMediators }));
        fetch('howToMeet')
            .then(response => response.json())
            .then(dataHowToMeets => this.setHowToMeets(dataHowToMeets));
        fetch('DocumentType')
            .then(response => response.json())
            .then(dataDocumentTypes => this.setDocumentTypes(dataDocumentTypes));

        this.getFormParameters();
        this.getSecureData();
    }

    private onUploadDocument = (event: any | undefined): void => {
        if (event == undefined || event.currentTarget == undefined || event.currentTarget.files == undefined || event.currentTarget.files.length == 0) {
            this.setState({ tempAttachment: null });
            return;
        }
        let file = event.currentTarget.files[0];

        //PDF Only
        if (!file.name.toLowerCase().endsWith('.pdf')) {
            this.setState({ invalidFileUpload: 'Error: Invalid file type. Only PDF files are supported.' });
            event.target.value = null;
            return;
        }
        else 
            this.setState({ invalidFileUpload: null });

        //5MB Limit
        if (file.size > 5242880) {
            this.setState({ invalidFileUpload: 'Error: File size is greater than 5MB.' });
            event.target.value = null;
            return;
        }
        else
            this.setState({ invalidFileUpload: null });

        this.setState({ tempAttachment: file });
    }


    private onChangeDropdown = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption<any> | undefined, index?: number | undefined): void => {
        let fieldId = (event.target as any).id;
        if (fieldId == "pt_documenttypeId") {
            this.setState({ pt_documenttypeId: option?.key });
            this.setState({ pt_documenttype: option?.text });
        }
        this.setState({ errorMessages: this.clearedErrorMessages((event.target as any).id), [(event.target as any).id]: option?.key });
    }

    private addDocumentForUpload = () => {
        this.setState({ documentTypeRequired: null });
        this.setState({ documentRequired: null });

        if (this.state.pt_documenttypeId === null || this.state.tempAttachment === null) {
            if (this.state.tempAttachment === null) {
                this.setState({ documentRequired: 'Document is a required field. Please select a document to upload.' });
            }
                
            if (this.state.pt_documenttypeId === null) {
                this.setState({ documentTypeRequired: 'Document Type is a required field. Please select a document type.' });
            }
        }
        else {

            let newDocument = [];
            newDocument.push({
                pt_DocumentName: this.state.tempAttachment.name,
                pt_DocumentType: this.state.pt_documenttype,
                pt_DocumentTypeId: this.state.pt_documenttypeId,
                recordIndex: this.state.documents.length + 1,
                docmanAnnotation: this.state.tempAttachment
            });

            this.state.documents = [].concat(this.state.documents, newDocument);

            this.resetFileUploadForm();
        }
    }

    private fileUploadDismissed = () => {
        this.resetFileUploadForm();
    }

    private fileUploadCloseClick = () => {
        this.resetFileUploadForm();
    }

    private resetFileUploadForm() {
        //Upload form controls
        this.setState({ uploadDocumentModalHidden: true });
        this.setState({ enableFileUploadOKButton: false });

        //State variables for file upload
        this.setState({ pt_documenttypeId: null });
        this.setState({ tempAttachment: null });

        this.setState({ documentRequired: null });
        this.setState({ documentTypeRequired: null });

        this.forceUpdate();
    }

    private setDocumentTypes(dataDocumentTypes) {
        this.setState({ documentTypes: dataDocumentTypes });

        //get the first item in the list to set it as a as a default value
        //if (dataDocumentTypes.length > 0) {
        //    this.setState({ pt_documenttypeId: dataDocumentTypes[0].key });
        //}
    }

    private setHowToMeets(dataHowToMeets) {
        this.setState({ howToMeets: dataHowToMeets });

        //get the first item in the list to set it as a as a default value
        if (dataHowToMeets.length > 0) {
            this.setState({ pt_nhowtomeet: dataHowToMeets[0].key });
        }
    }

    private getFormParameters() {
        const requestOptions = {
            method: 'GET'
        };
        fetch('PortalFormParameters?formType=' + this.state.referralFormat, requestOptions)
            .then(response => response.json())
            .then(portalParameters => this.loadPortalParameters(portalParameters))
            .then(() => this.setState({ showLoading: true }));
    }

    private loadPortalParameters(portalParameters) {
        this.setState({ pt_headertitle: portalParameters[0].headerTitle });
        this.setState({ pt_header: portalParameters[0].header });
        this.setState({ pt_footertitle: portalParameters[0].footerTitle });
        this.setState({ pt_footer: portalParameters[0].footer });
        //this.state.pt_headertitle = portalParameters[0].headerTitle;
        //this.state.pt_header = portalParameters[0].header;
        //this.state.pt_footertitle = portalParameters[0].footerTitle;
        //this.state.pt_footer = portalParameters[0].footer;
        this.setState({ showLoading: false })
    }

    private async getSecureData() {
        const queryString: string = window.location.search;
        const urlParams: URLSearchParams = new URLSearchParams(queryString);
        token = await authService.getAccessToken();

        fetch('user', { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
            .then(response => response.json())
            .then(dataUser => this.setState({
                user: dataUser,
                redirect: dataUser.contract === undefined,
                formState: CommonModels.FormState.LoadComplete,
                pt_ncontractnumber: dataUser.contract?.id,
                pt_nfilerfirstname: dataUser.firstName,
                pt_nfilerlastname: dataUser.lastName,
                pt_nfilertitle: dataUser.title,
                pt_nfileremail: dataUser.email,
                pt_nfilerphone: dataUser.phone,
                pt_nfilerphoneext: dataUser.ext,
            }));
        fetch('referralsubmissions?filter=' + this.state.referralFilter, { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
            .then(response => response.json())
            .then(dataReferrals => this.setState({ referrals: dataReferrals }));

        fetch('filter', { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
            .then(response => response.status !== 204 ? response.json() : [])
            .then(dataFilter => this.setState({ userFilters: dataFilter })) //, () => { console.log(this.state.userFilters);  this.createDateFilters()}));
            .then(() => { this.createDateFilters("Web Referral") });
    }

    private createDateFilters = (currentFormat: string): void => {
        let filterList: Array<CommonModels.KeyValuePair> = [{ key: "Past 25 Submissions", value: 25 }];

        //get the count of cases
        let caseCount = 0;

        //only sums up the case count for the given type we are looking at depending on the tab
        this.state.userFilters.forEach(a => {
            if (a.noticeFormat === currentFormat)
                caseCount += a.count;
        });

        if (caseCount > 25)
            filterList.push({ key: "Past 50 Submissions", value: 50 });

        if (caseCount > 50)
            filterList.push({ key: "Past 100 Submissions", value: 100 });

        this.state.userFilters.forEach(a => {
            if (a.noticeFormat === currentFormat)
                filterList.push({ key: a.label + " (" + a.count + ")", value: a.label });
        });

        this.setState({ filters: filterList });
    }

    private async copyRecord(detailsListSelection: Array<any>) {
        //debugger;
        if (detailsListSelection.length === 0) return;
        const token = await authService.getAccessToken();
        fetch(`copy?id=${detailsListSelection[0].id}`, { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
            .then(response => response.json())
            .then(dataCopy => this.updateCopyStateData(dataCopy))
            .then(final => this.setState({ cloneModalHidden: true, cloneModalLoading: false }));
        //fetch(`caseAdditionalEmails?id=${detailsListSelection[0].id}`)
        //    .then(response => response.json())
        //    .then(dataAdditionalEmails => this.loadAdditionalEmails(dataAdditionalEmails))
    }

    private updateCopyStateData(dataCopy) {
        dataCopy.pt_noticeemployeremail_confirm = dataCopy.pt_noticeemployeremail;
        //dataCopy.pt_noticeunionemail_confirm = dataCopy.pt_noticeunionemail;
        dataCopy.pt_ncounselrepemail_confirm = dataCopy.pt_ncounselrepemail;
        dataCopy.pt_nrespondentemail_confirm = dataCopy.pt_nrespondentemail;

        if (dataCopy.pt_noticeemployerstate !== null && dataCopy.pt_noticeemployerstate !== undefined) {
            let state = this.state.states.filter(function (value: CommonModels.State, index: number, arr) { return value.abbreviation == dataCopy.pt_noticeemployerstate })[0];
            dataCopy.pt_noticeemployerstate_selectedItems = [{ key: state.id, name: state.name }];
        }

        //if (dataCopy.pt_nrequestpreferredmediator != null && dataCopy.pt_nrequestpreferredmediator != undefined) {
        //    debugger;
        //    let preferredmediator = this.state.mediators.filter(function (value: CommonModels.Mediator, index: number, arr) { return value.id == dataCopy.pt_nrequestpreferredmediator })[0];
        //    dataCopy.pt_nrequestpreferredmediator_selectedItems = [{ key: preferredmediator.id, name: preferredmediator.fullName }];
        //}

        //if (dataCopy.pt_noticenegotiationstate != null && dataCopy.pt_noticenegotiationstate != undefined) {
        //    let state = this.state.states.filter(function (value: CommonModels.State, index: number, arr) { return value.id == dataCopy.pt_noticenegotiationstate })[0];
        //    dataCopy.pt_noticenegotiationstate_selectedItems = [{ key: state.id, name: state.name }];
        //}
        //if (dataCopy.pt_nbasisforcomplaint != null && dataCopy.pt_nbasisforcomplaint != undefined) {
        //    let filteredBasisForComplaint = this.state.complaints.filter(function (value: CommonModels.KeyValuePair, index: number, arr) { return value.key == dataCopy.pt_nbasisforcomplaint });
        //    if (filteredBasisForComplaint.length == 0) {
        //        dataCopy.pt_nbasisforcomplaint = null;
        //    }
        //}
        dataCopy.pt_nbasisforcomplaint = null;
        dataCopy.pt_nagencyreference = null;
        dataCopy.pt_nunioncontactfirstname = "";
        dataCopy.pt_nunioncontactlastname = "";
        dataCopy.pt_nadditionalcomplainants = null;
        dataCopy.pt_noticeunionphone = null;
        dataCopy.pt_ncomplainantphoneext = null;
        dataCopy.pt_noticeunionemail = null;
        dataCopy.pt_noticenegotiationcity = null;
        dataCopy.pt_noticenegotiationstate = null;
        dataCopy.pt_noticenegotiationzip = null;
        dataCopy.additionalEmail1 = null;
        dataCopy.additionalEmail2 = null;
        dataCopy.additionalEmail3 = null;
        dataCopy.additionalEmail4 = null;
        dataCopy.additionalEmail5 = null;
        dataCopy.additionalEmail6 = null;
        dataCopy.additionalEmail7 = null;
        dataCopy.additionalEmail8 = null;
        dataCopy.additionalEmail9 = null;

        this.setState(dataCopy);
    }

    //private loadAdditionalEmails(dataAdditionalEmails) {
    //    debugger;
    //    console.log(dataAdditionalEmails);
    //    var count = 1;
    //    this.state.additionalEmailsCopy = dataAdditionalEmails;
    //    let this2 = this;
    //    //dataAdditionalEmails.forEach(function (value) {
    //    this.state.additionalEmailsCopy.forEach(function (value) {
    //        console.log(value);
    //        if (count == 1) {
    //            this2.setState({ additionalEmail1: value.additionalEmail });
    //        }
    //        if (count == 2) { this2.setState({ additionalEmail2: value.additionalEmail }); }
    //        if (count == 3) { this2.setState({ additionalEmail3: value.additionalEmail }); }
    //        if (count == 4) { this2.setState({ additionalEmail4: value.additionalEmail }); }
    //        if (count == 5) { this2.setState({ additionalEmail5: value.additionalEmail }); }
    //        if (count == 6) { this2.setState({ additionalEmail6: value.additionalEmail }); }
    //        if (count == 7) { this2.setState({ additionalEmail7: value.additionalEmail }); }
    //        if (count == 8) { this2.setState({ additionalEmail8: value.additionalEmail }); }
    //        if (count == 9) { this2.setState({ additionalEmail9: value.additionalEmail }); }
    //        count++;            
    //    });
    //}

    private resetFormData = () => {
        this.setState({ showLoading: true });
        let ignoreFields: Array<string> = ["pt_f7noticesubmissionformat", "pt_nreceiveddate", "pt_receiveddate", "pt_notices", "pt_nsector", "pt_sector", "pt_noticecasetype", "pt_nfilerfirstname", "pt_nfilerlastname", "pt_nfilertitle", "pt_nfileremail"];
        let localState = this.state;
        this.getFormParameters();
        localState.documents = [];
        localState.dialogResetHidden = true;
        localState.errorMessages = [];
        localState.additionalEmails = [];
        localState.additionalEmail1 = null;
        localState.additionalEmail2 = null;
        localState.additionalEmail3 = null;
        localState.additionalEmail4 = null;
        localState.additionalEmail5 = null;
        localState.additionalEmail6 = null;
        localState.additionalEmail7 = null;
        localState.additionalEmail8 = null;
        localState.additionalEmail9 = null;
        localState.formState = CommonModels.FormState.LoadComplete;
        for (var p in localState) {
            if (p.indexOf("pt_") > -1 && !ignoreFields.includes(p)) {
                if (typeof localState[p] === 'string') {
                    localState[p] = '';
                }
                else if (typeof localState[p] === 'number') {
                    localState[p] = 0;
                }
                else if (localState[p] instanceof Date) {
                    localState[p] = null;
                }
                else if (p.indexOf("_selectedItems") > -1) {
                    localState[p] = [];
                }
                else {
                    console.log(typeof localState[p]);
                }
            }
        }
        this.setState(localState);
    }

    private getErrorMessage = (errorMessages: Array<CommonModels.KeyValuePair>, id: string): string => {
        let controlErrors: Array<CommonModels.KeyValuePair> = errorMessages.filter(function (v, i) { return v.key == id });
        if (controlErrors.length > 0) {
            return (controlErrors[0].value as Array<string>).join("\n");
        }
        return "";
    };

    private clearedErrorMessages = (field: string): Array<CommonModels.KeyValuePair> => {
        let _errorMessages = this.state.errorMessages as Array<CommonModels.KeyValuePair>;
        _errorMessages.forEach(a => { if (a.key === field) { a.value = []; } });
        return _errorMessages;
    }

    private onChangeField = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string): void => {
        if (event.currentTarget.id === "pt_noticenegotiationzip") {
            if (event.currentTarget.value !== null && (event.currentTarget.value.length === 5 || event.currentTarget.value.length === 9)) {
                fetch('zipcode?zip=' + event.currentTarget.value)
                    .then(response => response.json())
                    .then(dataZip => {
                        console.log(dataZip);
                        if (dataZip[0] === true) {
                            this.setState({ pt_negotiationzipvalidationstatus: zipValidationStatusOptions.ValidZip });
                        }
                        else {
                            //Didn't find zip in CRM, Query AzureAPI to see if it's valid.
                            this.onExecuteValidateZip(this.state.pt_noticenegotiationzip, true);
                        }
                    });
            }
        }

        this.setState({ errorMessages: this.clearedErrorMessages(event.currentTarget.id), [event.currentTarget.id]: event.currentTarget.value });
    }

    private onExecuteValidateZip = (zip: string, isSearchAction: boolean) => {
        let requestUrl = this.state.addresssGeocodeServiceUrlTemplate.replace('{query}', encodeURIComponent(zip))
            .replace('{language}', this.state.azMapsLanguage)
            .replace('{countrySet}', this.state.azMapsCoutrySet)
            .replace('{key}', this.state.azMapsKey); //A comma seperate

        fetch(requestUrl)
            .then(res => res.json())
            .then(
                (data) => {
                    debugger;
                    let foundGeography = false;
                    if (data.results.length != 0) {
                        for (var i = 0; i < data.results.length; i++) {
                            if (data.results[i].type === "Geography") {
                                foundGeography = true;
                            }
                        }
                    }
                    if (foundGeography) {
                        this.setState({ pt_negotiationzipvalidationstatus: zipValidationStatusOptions.MissinginCRM });
                    }
                    else
                        this.setState({ pt_negotiationzipvalidationstatus: zipValidationStatusOptions.InvalidZip });
                },
                (error) => {
                    this.setState({ isLoaded: true, error });
                }
            )
    }

    //private onChangeAdditionalEmails = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string): void => {
    //    this.setState({ errorMessages: this.clearedErrorMessages(event.currentTarget.id), [event.currentTarget.id]: event.currentTarget.value });

    //    const addEmail: CommonModels.CaseAdditionalEmail = {
    //        pt_AdditionalEmail: event.currentTarget.value,//this['information_' + datum]
    //        pt_ConfirmationNoticeNumber: null,
    //        pt_Name: null,
    //        pt_Case: null
    //    };
    //    this.state.additionalEmails.push(addEmail);
    //}

    private onNotifyValidationResult = (logicalName: string, errorMessage: string | JSX.Element, value: string | undefined): void => {
        this.setState({ errorMessages: this.clearedErrorMessages(logicalName), [logicalName]: value.replace(/[\W_]+/g, "") });
    }

    private CheckFileUpload = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption<any> | undefined, index?: number | undefined): void => {
        this.setState({ errorMessages: this.clearedErrorMessages((event.target as any).id), [(event.target as any).id]: option?.key });

        //if (this.state.pt_documenttypeId !== '') {
        //    alert('has value');
        //}
    }

    private onChangeFilterDropdown = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption<any> | undefined, index?: number | undefined): void => {
        this.setState({ filterYear: option?.key });
        this.setState({ showLoading: false });

        //Get the requests
        this.setState({ referralFilter: option?.key });

        fetch('referralsubmissions?filter=' + option?.key, { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } })
            .then(response => response.status !== 204 ? response.json() : [])
            .then(dataReferralSubmissions => this.setState({ referrals: dataReferralSubmissions }))
            .then(() => this.setState({ showLoading: true }))
            .then(() => { console.log("Referral Submissions: " + this.state.referrals.length) });
    };

    private onChangeCombobox = (logicalName: string, option?: IComboBoxOption): void => {
        this.setState({ errorMessages: this.clearedErrorMessages(logicalName), [logicalName]: option?.key });
    }

    private onChangeTagPickerMediator = (logicalName: string, items?: ITag[] | undefined): void => {
        if (items === undefined || items?.length === 0) {
            this.setState({ errorMessages: this.clearedErrorMessages(logicalName), [logicalName]: undefined, [`${logicalName}_selectedItems`]: items });
            return;
        }
        this.setState({ errorMessages: this.clearedErrorMessages(logicalName), [logicalName]: items[0].key, [`${logicalName}_selectedItems`]: items });
    }

    private onChangeTagPickerState = (logicalName: string, items?: ITag[] | undefined, saveIdProperty?: boolean): void => {
        if (items === undefined || items?.length === 0) {
            this.setState({ errorMessages: this.clearedErrorMessages(logicalName), [logicalName]: undefined, [`${logicalName}_selectedItems`]: items });
            return;
        }
        let state = this.state.states.filter(function (value: CommonModels.State, index: number, arr) { return value.id == items[0].key })[0];
        if (saveIdProperty != undefined && saveIdProperty) {
            this.setState({ errorMessages: this.clearedErrorMessages(logicalName), [logicalName]: state.id, [`${logicalName}_selectedItems`]: items });
        }
        else {
            this.setState({ errorMessages: this.clearedErrorMessages(logicalName), [logicalName]: state.abbreviation, [`${logicalName}_selectedItems`]: items });
        }
    }

    private onRenderSuggestionsItemState = (props: ITag, itemProps: ISuggestionItemProps<ITag>): JSX.Element => {
        let union = this.state.states.filter(function (value: CommonModels.State, index: number, arr) { return value.id == props.key })[0];
        return <div className={classNames.itemCell} data-is-focusable={false} style={{ width: "100%", alignContent: "left" }}>
            <div className={classNames.itemContent}>
                <div className={classNames.itemName}>{union.abbreviation}</div>
                {union.name}
            </div>
            <Icon className={classNames.chevron} iconName={'ChevronRight'} />
        </div>
    }

    private onRenderSuggestionsItemMediator = (props: ITag, itemProps: ISuggestionItemProps<ITag>): JSX.Element => {
        let mediator = this.state.mediators.filter(function (value: CommonModels.Mediator, index: number, arr) { return value.id == props.key })[0];
        return <div className={classNames.itemCell} data-is-focusable={false} style={{ width: "100%", alignContent: "left" }}>
            <div className={classNames.itemContent}>
                <div className={classNames.itemName}>{mediator.lastName}</div>
                {mediator.firstName}
            </div>
            <Icon className={classNames.chevron} iconName={'ChevronRight'} />
        </div>
    }

    private onResolveSuggestionsState = (filterText: string, tagList: ITag[] | undefined): ITag[] => {
        if (filterText == undefined || filterText.trim().length == 0) return [];
        /*return this.state.states.filter(keyValue => (keyValue.name != null && keyValue.name.toLowerCase().startsWith(filterText.toLowerCase())) || (keyValue.abbreviation != null && keyValue.abbreviation.toLowerCase().startsWith(filterText.toLowerCase()))).map(item => { let stateSuggestion: ITag = { key: item.id, name: item.abbreviation }; return stateSuggestion; });*/
        return this.state.states.filter(keyValue => (keyValue.abbreviation != null && keyValue.abbreviation.toLowerCase().indexOf(filterText.toLowerCase()) > -1)).map(item => { let stateSuggestion: ITag = { key: item.id, name: item.abbreviation }; return stateSuggestion; });
    };

    private onFilterChangedEmployerAddress = (newValue?: string | undefined) => {
        this.setState({ pt_noticeemployeraddressline1: newValue });
        if (newValue === undefined) {
            this.setState({ isLoaded: true, eCalloutVisible: false });
            return;
        }
        if (newValue.length < this.state.addressSearchMinLength) {
            return;
        }
        setTimeout(() => { this.onExecuteQueryEmployerAddress(newValue, true); }, 1000);
    }

    private onExecuteQueryEmployerAddress = (queryValue: string, isSearchAction: boolean) => {
        this.setState({ searchAddresses: [] });
        let requestUrl = this.state.addresssGeocodeServiceUrlTemplate.replace('{query}', encodeURIComponent(queryValue))
            .replace('{language}', this.state.azMapsLanguage)
            .replace('{countrySet}', this.state.azMapsCoutrySet)
            .replace('{key}', this.state.azMapsKey); //A comma seperate

        fetch(requestUrl)
            .then(res => res.json())
            .then(
                (data) => {
                    let addressResults: Array<any> = [];

                    if (this.state.searchAddresses.length > 0)
                        this.state.searchAddresses = [];

                    for (var i = 0; i < data.results.length; i++) {
                        this.state.searchAddresses.push(data.results[i].address)
                    }

                    if (isSearchAction) {
                        this.setState({ isLoaded: true, eCalloutVisible: true, addressResults: addressResults, response: JSON.stringify(data) });
                    } else if (!isSearchAction && addressResults.length > 0) {
                        this.setState({ address: addressResults[0] });//, this.renderMap);
                    }
                },
                (error) => {
                    this.setState({ isLoaded: true, error });
                }
            )
    }

    private setEmpAddressSelectedValue(newValue: any) {
        this.setState({ eCalloutVisible: false });//, address: newValue.length > 0 ? newValue[0] : undefined });        
        if (newValue.length > 0) {
            if (newValue[0].streetNumber !== undefined && newValue[0].streetName != undefined) {
                this.setState({ pt_noticeemployeraddressline1: newValue[0].streetNumber + " " + newValue[0].streetName });
            } else if (newValue[0].streetName !== undefined) {
                this.setState({ pt_noticeemployeraddressline1: newValue[0].streetName });
            }

            this.setState({ pt_noticeemployercity: newValue[0].localName });
            this.setState({ pt_noticeemployerzip: newValue[0].postalCode });

            let stateId = this.state.states.find(i => i.abbreviation === newValue[0].countrySubdivision).id;
            let stateITag: ITag = {
                name: newValue[0].countrySubdivision,
                key: stateId
            }

            const items: ITag[] = new Array();
            items.push(stateITag);
            this.onChangeTagPickerState("pt_noticeemployerstate", items);
        }
        if (this.state.controlCallback === undefined)
            return
    }

    private customRequirementRules = (): void => {
        //reset the requirement rules back to their original state
        let resetRequirementRules = ["pt_nbasisforcomplaint",
            "pt_nunioncontactfirstname",
            "pt_nunioncontactlastname",
            "pt_noticeunionphone",
            "pt_noticeunionemail",
            "pt_ncounselrepfirstname",
            "pt_ncounselreplastname",
            "pt_ncounselrepphone",
            "pt_ncounselrepemail",
            "pt_nrespondentcontactfirstname",
            "pt_nrespondentcontactlastname",
            "pt_nrespondentphone",
            "pt_nrespondentemail",
            "additionalEmail1",
            "additionalEmail2",
            "additionalEmail3",
            "additionalEmail4",
            "additionalEmail5",
            "additionalEmail6",
            "additionalEmail7",
            "additionalEmail8",
            "additionalEmail9"
        ];

        invalid = [];
        required = required.filter(function (value: CommonModels.KeyValuePair, index: number, arr) {
            return (resetRequirementRules.filter(f => f === value.key).length === 0);
        });

        let basisForComplaintRequired: boolean = (
            this.state.pt_nunioncontactfirstname?.length > 0 ||
            this.state.pt_nunioncontactlastname?.length > 0
        );
        let complainantRequired: boolean = (
            this.state.pt_nunioncontactfirstname?.length > 0 ||
            this.state.pt_nunioncontactlastname?.length > 0
        );

        let counselRepRequired: boolean = (
            this.state.pt_ncounselrepfirstname?.length > 0 ||
            this.state.pt_ncounselreplastname?.length > 0
        );
        let respondentRequired: boolean = (
            this.state.pt_nrespondentname?.length > 0
        );

        if (basisForComplaintRequired) {
            required.push({ key: "pt_nbasisforcomplaint", value: "Complainant Information - Basis for complaint is required" });
        }
        if (complainantRequired) {
            required.push({ key: "pt_nunioncontactfirstname", value: "Complainant Information - First Name is required" });
            required.push({ key: "pt_nunioncontactlastname", value: "Complainant Information - Last Name is required" });
            required.push({ key: "pt_noticeunionphone", value: "Complainant Information - Phone is required" });
            required.push({ key: "pt_noticeunionemail", value: "Complainant Information - Business Email is required" });
        }
        if (counselRepRequired) {
            required.push({ key: "pt_ncounselrepfirstname", value: "Counsel/Rep - First Name is required" });
            required.push({ key: "pt_ncounselreplastname", value: "Counsel/Rep - Last Name is required" });
            required.push({ key: "pt_ncounselrepphone", value: "Counsel/Rep - Phone is required" });
            required.push({ key: "pt_ncounselrepemail", value: "Counsel/Rep - Business Email is required" });
        }
        if (respondentRequired) {
            required.push({ key: "pt_nrespondentcontactfirstname", value: "Respondent Information - First Name is required" });
            required.push({ key: "pt_nrespondentcontactlastname", value: "Respondent Information - Last Name is required" });
            required.push({ key: "pt_nrespondentphone", value: "Respondent Information - Phone is required" });
            required.push({ key: "pt_nrespondentemail", value: "Respondent Information - Business Email is required" });
        }

        //validate emails
        let validateEmail: Array<CommonModels.KeyValuePair> = [
            { key: "pt_noticeemployeremail", value: "Agency Contact - Business Email is invalid" },
            { key: "pt_noticeunionemail", value: "Complainant Information - Business Email is invalid" },
            { key: "pt_ncounselrepemail", value: "Counsel/Rep - Business Email is invalid" },
            { key: "pt_nrespondentemail", value: "Respondent Information - Business Email is invalid" },
            { key: "pt_noticeemployeremail_confirm", value: "Agency Contact - Confirm Email is invalid" },
            { key: "pt_noticeunionemail_confirm", value: "Complainant Information - Confirm Email is invalid" },
            { key: "pt_ncounselrepemail_confirm", value: "Counsel/Rep - Confirm Email is invalid" },
            { key: "pt_nrespondentemail_confirm", value: "Respondent Information - Confirm Email is invalid" },
            { key: "additionalEmail1", value: "Additional Email 1 is invalid" },
            { key: "additionalEmail2", value: "Additional Email 2 is invalid" },
            { key: "additionalEmail3", value: "Additional Email 3 is invalid" },
            { key: "additionalEmail4", value: "Additional Email 4 is invalid" },
            { key: "additionalEmail5", value: "Additional Email 5 is invalid" },
            { key: "additionalEmail6", value: "Additional Email 6 is invalid" },
            { key: "additionalEmail7", value: "Additional Email 7 is invalid" },
            { key: "additionalEmail8", value: "Additional Email 8 is invalid" },
            { key: "additionalEmail9", value: "Additional Email 9 is invalid" }
        ];
        validateEmail.forEach(a => {
            if (this.state[a.key] == null || this.state[a.key].trim().length === 0) return;
            if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/.test(this.state[a.key].trim()))) {
                invalid.push({ key: a.key, value: a.value });
            }
        });

        if (this.state.pt_noticeemployeremail != null && this.state.pt_noticeemployeremail_confirm != null && this.state.pt_noticeemployeremail != this.state.pt_noticeemployeremail_confirm) {
            invalid.push({ key: "pt_noticeemployeremail_confirm", value: "Agency Contact - Confirmation Email must match" });
        }
        if (this.state.pt_noticeunionemail != null && this.state.pt_noticeunionemail_confirm != null && this.state.pt_noticeunionemail != this.state.pt_noticeunionemail_confirm) {
            invalid.push({ key: "pt_noticeunionemail_confirm", value: "Complainant Information - Confirmation Email must match" });
        }
        if (this.state.pt_ncounselrepemail != null && this.state.pt_ncounselrepemail_confirm != null && this.state.pt_ncounselrepemail != this.state.pt_ncounselrepemail_confirm) {
            invalid.push({ key: "pt_ncounselrepemail_confirm", value: "Counsel/Rep - Confirmation Email must match" });
        }
        if (this.state.pt_nrespondentemail != null && this.state.pt_nrespondentemail_confirm != null && this.state.pt_nrespondentemail != this.state.pt_nrespondentemail_confirm) {
            invalid.push({ key: "pt_nrespondentemail_confirm", value: "Respondent Information - Confirmation Email must match" });
        }

        //validate phone
        let validatePhone: Array<CommonModels.KeyValuePair> = [
            { key: "pt_noticeemployerphone", value: "Agency Contact - Phone is invalid" },
            { key: "pt_nrespondentphone", value: "Respondent Information - Phone is invalid" }
        ];
        validatePhone.forEach(a => {
            if (this.state[a.key] == null) return;
            var numericPhone = this.state[a.key].replace(/\D/g, '');
            if (numericPhone.length > 0 && numericPhone.length != 10) {
                invalid.push({ key: a.key, value: a.value });
            }
        });

        //validate area code
        let validateAreaCode: Array<CommonModels.KeyValuePair> = [
            { key: "pt_noticeemployerphone", value: "Agency Contact - Phone Area Code is invalid" },
            { key: "pt_noticeunionphone", value: "Complainant Information - Phone Area Code is invalid" },
            { key: "pt_ncounselrepphone", value: "Counsel/Rep - Phone Area Code is invalid" },
            { key: "pt_nrespondentphone", value: "Respondent Information - Phone Area Code is invalid" }
        ];
        validateAreaCode.forEach(a => {
            if (this.state[a.key] == null) return;
            var numericPhone = this.state[a.key].replace(/\D/g, '');
            if (numericPhone.length > 0) {
                var areaCode = numericPhone.substring(0, 3);
                var areaCodeNumber: number = +areaCode;
                if (numericPhone.length > 0 && areaCodeNumber < 201) {
                    invalid.push({ key: a.key, value: a.value });
                }
            }
        });

        //validate zip
        let validateZip: Array<CommonModels.KeyValuePair> = [
            { key: "pt_noticeemployerzip", value: "Referring Employer/Agency - Zip is invalid" },
            { key: "pt_noticeunionzip", value: "Complainant Information - Zip is invalid" },
            { key: "pt_noticenegotiationzip", value: "Location of Requested Mediation - Zip is invalid" },
        ];

        //debugger;
        validateZip.forEach(a => {
            if (this.state[a.key] === null || this.state[a.key] === undefined) return;
            if (this.state[a.key].charAt(this.state[a.key].length - 1) === "-") {
                // let fieldName = a.key;
                // let zip = this.state[a.key].substring(0, this.state[a.key].length - 1);
                //this.setState({ fieldName : zip });
                this.state[a.key] = this.state[a.key].substring(0, this.state[a.key].length - 1);
            }
            var numericZip = this.state[a.key].replace(/\D/g, '');
            if (numericZip.length > 0 && (numericZip.length !== 5 && numericZip.length !== 9)) {
                invalid.push({ key: a.key, value: a.value });
            }
        });

        console.log("zip " + this.state.pt_noticenegotiationzip);
        if (this.state.pt_noticenegotiationzip !== undefined && this.state.pt_negotiationzipvalidationstatus === zipValidationStatusOptions.InvalidZip) {

            //if (!invalid.find({ key: "pt_noticenegotiationzip", value: "Location of Negotiation - Zip is invalid" })) {
            if (invalid.find(({ key }) => key === "pt_noticenegotiationzip") === undefined) {
                console.log("adding our message");
                invalid.push({ key: "pt_noticenegotiationzip", value: "Location of Negotiation - Zip is invalid" });
            }
        }

        this.setState({ requiredBasisForComplaint: basisForComplaintRequired, requiredComplainant: complainantRequired });
    }

    private renderDropdownOption = (keyField: string, valueField: string, data: Array<any>): IDropdownOption[] => {
        let options: IDropdownOption[] = [];
        data.forEach(a => { options.push({ key: a[keyField], text: a[valueField] }); });
        return options;
    }

    private onResolveSuggestionsHeardFromMediator = (filterText: string, tagList: ITag[] | undefined): ITag[] => {
        if (filterText == undefined || filterText.trim().length == 0) return [];
        return this.state.mediators.filter(keyValue => (keyValue.lastName != null && keyValue.lastName.toLowerCase().indexOf(filterText.toLowerCase()) > -1) || (keyValue.firstName != null && keyValue.firstName.toLowerCase().indexOf(filterText.toLowerCase()) > -1)).map(item => { let mediatorSuggestion: ITag = { key: item.id, name: item.fullName }; return mediatorSuggestion; });
    };

    private cloneSelection = new Selection({
        onSelectionChanged: () => this.setState({ selectionCount: this.cloneSelection.getSelectedCount(), selection: this.cloneSelection.getSelection() }),
    });

    private cloneRenderItemColumn = (item: any, index: number, column: IColumn): JSX.Element => {
        const fieldContent = item[column.fieldName] as string;

        switch (column.key) {
            case 'view':
                if (item.pt_SourceReferralCreated)
                    return <Link href={`/Annotations?id=${item.id}`} target="_blank">REFERAL</Link>;
                else
                    return;
            case 'createdOn':
                let localDate: Date = new Date(item[column.fieldName]);
                let month = '' + (localDate.getMonth() + 1);
                let day = '' + localDate.getDate();
                let year = localDate.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;

                return <span>{[year, month, day].join('-')}</span>;
            default:
                return <span>{fieldContent}</span>;
        }
    }

    private onSubmitForm = (event: any): void => {
        let newStateData: any = {};

        newStateData.pt_noticeemployercontact = `${this.state.pt_nemployercontactfirstname} ${this.state.pt_nemployercontactlastname}`;
        newStateData.pt_nrespondentcontact = `${this.state.pt_nrespondentcontactfirstname} ${this.state.pt_nrespondentcontactlastname}`;
        newStateData.pt_ncounselrep = `${this.state.pt_ncounselrepfirstname} ${this.state.pt_ncounselreplastname}`;
        newStateData.pt_noticeunioncontact = `${this.state.pt_nunioncontactfirstname} ${this.state.pt_nunioncontactlastname}`;

        this.customRequirementRules();

        this.setState(newStateData, function () {
            let _errorMessages: Array<CommonModels.KeyValuePair> = [];

            invalid.forEach(a => {
                _errorMessages.push({ key: a.key, value: [a.value] });
            });

            required.forEach(a => {
                if (!this.state[a.key]) {
                    _errorMessages.push({ key: a.key, value: [a.value] })
                }
            });

            if (_errorMessages.length > 0) {
                this.setState({ formSubmitted: true, dialogHidden: false, errorMessages: _errorMessages });
                return;
            }

            this.setState({ formState: CommonModels.FormState.OnSave, formSubmitted: true });

            let additionalEmailFields = ["additionalEmail1", "additionalEmail2", "additionalEmail3", "additionalEmail4", "additionalEmail5", "additionalEmail6", "additionalEmail7", "additionalEmail8", "additionalEmail9"]
            // this.setState({ additionalEmails: [] });

            additionalEmailFields.forEach(a => {
                console.log(a);
                console.log(this.state[a]);
                if (this.state[a] !== undefined && this.state[a] !== null) {
                    let addEmail: CommonModels.CaseAdditionalEmail = {
                        pt_AdditionalEmail: this.state[a],
                        pt_ConfirmationNoticeNumber: null,
                        pt_Name: null,
                        pt_Case: null
                    };

                    this.state.additionalEmails.push(addEmail);
                }
            });

            this.submitData();
        });

    }

    private async downloadAnnotation(id: string) {
        const token = await authService.getAccessToken();
        window.open(`annotations?id=${id}&token=${encodeURIComponent(token)}`);
    }

    private documentSelection = new Selection({
        onSelectionChanged: () => this.setState({ documentSelectionCount: this.documentSelection.getSelectedCount(), documentSelection: this.documentSelection.getSelection() }),
    });

    private renderItemColumn = (item: any, index: number, column: IColumn): JSX.Element => {
        const fieldContent = item[column.fieldName] as string;
        return <span>{fieldContent}</span>;

        //switch (column.key) {
        //    case 'pt_DocumentName':
        //        return <span>{item.mediatorInfo.name}<br /><small><a href={"mailto:" + item.mediatorInfo.email}>{item.mediatorInfo.email}</a><br />{item.mediatorInfo.phone}</small></span>;;
        //}
        //return;
    }

    private _onItemInvoked = (item: any): void => {
        console.log(item);
    };

    private async submitData() {
        const token = await authService.getAccessToken();
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify(this.state)
        };
        fetch('ReferralSubmissions', requestOptions)
            .then(response => response.json())
            .then(referralRecordResponse => this.createAddtionalEmails(referralRecordResponse))
    }

    private async submitAnnotation(id: string) {
        if (!this.state.documents) {
            this.setState({ formState: CommonModels.FormState.SaveComplete });
            return;
        }

        let formData: FormData = new FormData();
        formData.append('Id', id);
        formData.append('LogicalName', "pt_fmcscase");
        for (var i = 0; i < this.state.documents.length; i++) {
            formData.append('FormFile', this.state.documents[i].docmanAnnotation);
            formData.append('DocumentType', this.state.documents[i].pt_DocumentTypeId);
        }
        const token = await authService.getAccessToken();
        const requestOptions = {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` },
            body: formData
        };
        fetch('DocMan', requestOptions)
            .then(response => response.text())
            .then((responseText) => this.setState({ formState: CommonModels.FormState.SaveComplete }));
    }

    private async createAddtionalEmails(referralRecordResponse) {
        // this.setState({ formState: CommonModels.FormState.SaveComplete, referralrecord: referralRecordResponse });
        this.setState({ referralrecord: referralRecordResponse });
        let fmcsCaseID = referralRecordResponse.id;
        let confirmationNumber = referralRecordResponse.pt_ConfirmationNoticeNumber;

        this.state.additionalEmails.forEach(i => i.pt_Case = fmcsCaseID);
        this.state.additionalEmails.forEach(i => i.pt_ConfirmationNoticeNumber = confirmationNumber);

        const token = await authService.getAccessToken();
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify(this.state.additionalEmails)
        };
        fetch('caseAdditionalEmails', requestOptions)
            .then(response => response.json())
            .then(responseRecords => this.submitAnnotation(fmcsCaseID));
    }

    private filterDocumentCollection(element, index, array) {
        return (selectedDocument.recordIndex != element.recordIndex);
    }

    private removeDocument() {
        selectedDocument = this.state.documentSelection[0];
        this.setState({ documents: this.state.documents.filter(this.filterDocumentCollection) });
    }

    //private async(caseId) {
    //    const token = await authService.getAccessToken();
    //    const requestOptions = {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
    //        body: JSON.stringify(this.state)
    //}

    private uploadDocumentClicked() {
        this.setState({ uploadDocumentModalHidden: false });
        this.state.tempAttachment = null;
    }

    public render() {

        const documentUploadCommandBarItems = [
            {
                key: 'uploaddocument',
                text: 'Upload Document',
                className: styles.documentStyles,
                onClick: () => this.uploadDocumentClicked(),
                disabled: this.state.documents.length >= 9
            },
            {
                key: 'removedocument',
                text: 'Remove Selected',
                className: styles.documentStyles,
                disabled: this.state.documentSelectionCount == 0,
                onClick: () => this.removeDocument()
            }
        ];

        const { redirect } = this.state;

        if (redirect) {
            return (<Redirect to='/Contract' />);
        }

        return (
            <Stack>

                <StackItem style={{ display: this.state.formState === CommonModels.FormState.LoadComplete ? "block" : "none" }}>

                    <MessageBar messageBarType={MessageBarType.success} isMultiline={false}
                        actions={
                            <div>
                                <MessageBarButton onClick={e => this.setState({ redirect: true })}>Change Contract</MessageBarButton>
                            </div>
                        }>
                        You are submitting a referral for contract <strong>{this.state.user?.contract?.name}</strong>.
                    </MessageBar>

                    <MessageBar messageBarType={MessageBarType.warning} isMultiline={false} styles={{ root: { display: this.state.dismissClonePrompt == false && this.state.referrals?.length > 0 ? "block" : "none" } }}
                        actions={
                            <div>
                                <MessageBarButton onClick={e => this.setState({ cloneModalHidden: false })}>Select</MessageBarButton>
                            </div>
                        }>
                        Would you like to pre-populate this form using one of your past submissions?
                    </MessageBar>

                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Text variant={"xLarge" as ITextProps['variant']}>{<div className="content" dangerouslySetInnerHTML={{ __html: this.state.pt_headertitle }}></div>}</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                {<div className="content" dangerouslySetInnerHTML={{ __html: this.state.pt_header }}></div>}
                            </StackItem>
                        </Stack>
                    </div>

                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Text variant={"xLarge" as ITextProps['variant']}>Referring Employer/Agency</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                <TextField label="Agency" id="pt_noticeemployer" value={this.state.pt_noticeemployer} maxLength={100} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployer")} required />
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Bureau / Subdivision" id="pt_nbureau" value={this.state.pt_nbureau} maxLength={65} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nbureau")} />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Office " id="pt_noffice" value={this.state.pt_noffice} maxLength={65} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noffice")} />
                                    </StackItem>
                                </Stack>
                            </StackItem>

                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Address Line 1" id="pt_noticeemployeraddressline1" value={this.state.pt_noticeemployeraddressline1}
                                            autoComplete="off"
                                            onChange={(event?: React.ChangeEvent<HTMLInputElement> | undefined, newValue?: string | undefined) => this.onFilterChangedEmployerAddress(newValue)}
                                            maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployeraddressline1")} required />
                                    </StackItem>

                                    {this.state.eCalloutVisible && (
                                        <Callout
                                            styles={{ root: { width: "50%", maxWidth: "80%", padding: "5px 5px", backgroundColor: "white" } }}
                                            isBeakVisible={false}
                                            gapSpace={0}
                                            target={`#${this.state.employerAddressSearchId}`}
                                            onDismiss={e => this.setState({ eCalloutVisible: false })}
                                            directionalHint={DirectionalHint.bottomLeftEdge}
                                            role="alertdialog"
                                            setInitialFocus={true}>
                                            <DetailsList
                                                //styles={{ root: { width: "150", padding: "3px 3px" } }}
                                                items={this.state.searchAddresses}
                                                data-is-focusable={true}
                                                compact={true}
                                                columns={addressColumns}
                                                setKey="EmployerAddressSuggestions"
                                                layoutMode={DetailsListLayoutMode.justified}
                                                constrainMode={ConstrainMode.unconstrained}
                                                selectionMode={SelectionMode.single}
                                                selection={this._eSelection}
                                                //selectionPreservedOnEmptyClick={true}
                                                isHeaderVisible={false}
                                                onShouldVirtualize={() => false} />
                                        </Callout>
                                    )}

                                    <StackItem grow>
                                        <TextField label="Address Line 2" id="pt_noticeemployeraddressline2" value={this.state.pt_noticeemployeraddressline2} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployeraddressline2")} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="City" id="pt_noticeemployercity" value={this.state.pt_noticeemployercity} onChange={this.onChangeField} maxLength={50} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployercity")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <Label>State <span style={{ color: "rgb(164, 38, 44)" }}>*</span></Label>
                                        <TagPicker itemLimit={1} selectedItems={this.state.pt_noticeemployerstate_selectedItems} styles={{ input: this.getErrorMessage(this.state.errorMessages, "pt_noticeemployerstate").length > 0 ? { borderColor: "rgb(164, 38, 44)", border: "solid 1px" } : {} }}
                                            removeButtonAriaLabel="Remove"
                                            pickerCalloutProps={{ doNotLayer: true }} //keep this for accessibility
                                            onResolveSuggestions={this.onResolveSuggestionsState}
                                            onChange={(items?: ITag[] | undefined) => { this.onChangeTagPickerState("pt_noticeemployerstate", items) }}
                                            onRenderSuggestionsItem={this.onRenderSuggestionsItemState}
                                            getTextFromItem={(item: ITag) => item.name}
                                            pickerSuggestionsProps={{ suggestionsHeaderText: 'Suggested States', noResultsFoundText: 'No states found' }}
                                            inputProps={{
                                                'aria-label': 'Type state or abbreviation',
                                                placeholder: 'Type state or abbreviation',
                                                autoComplete: "none"
                                            }}
                                        />
                                        <div role="alert" className="errorMessage" style={{ color: "rgb(164, 38, 44)", fontSize: "12px", height: "23px", lineHeight: "18px", paddingTop: "5px", display: this.getErrorMessage(this.state.errorMessages, "pt_noticeemployerstate").length > 0 ? "block" : "none" }}>{this.getErrorMessage(this.state.errorMessages, "pt_noticeemployerstate")}</div>
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Zip Code" alt="zipmask" id="pt_noticeemployerzip" value={this.state.pt_noticeemployerzip} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployerzip")} required />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <hr />
                            </StackItem>
                        </Stack>

                        <Text variant={"xLarge" as ITextProps['variant']}>Agency Contact</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="First Name" id="pt_nemployercontactfirstname" value={this.state.pt_nemployercontactfirstname} onChange={this.onChangeField} maxLength={25} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nemployercontactfirstname")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Last Name" id="pt_nemployercontactlastname" value={this.state.pt_nemployercontactlastname} onChange={this.onChangeField} maxLength={25} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nemployercontactlastname")} required />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField id="pt_noticeemployerphone" alt="phonemask" value={this.state.pt_noticeemployerphone} label="Phone Number" onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployerphone")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Ext" id="pt_nemployerphoneext" value={this.state.pt_nemployerphoneext} onChange={this.onChangeField} maxLength={10} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nemployerphoneext")} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Business Email" id="pt_noticeemployeremail" value={this.state.pt_noticeemployeremail} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployeremail")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Confirm Email" id="pt_noticeemployeremail_confirm" value={this.state.pt_noticeemployeremail_confirm} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployeremail_confirm")} required />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                        </Stack>
                    </div>

                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Text variant={"xLarge" as ITextProps['variant']}>Complainant Information</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <Dropdown label="Complaint" id="pt_nbasisforcomplaint" selectedKey={this.state.pt_nbasisforcomplaint} onChange={this.onChangeDropdown} options={this.renderDropdownOption("key", "value", this.state.complaints)} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nbasisforcomplaint")}
                                            required={
                                                this.state.pt_nunioncontactfirstname?.length > 0 ||
                                                this.state.pt_nunioncontactlastname?.length > 0
                                            } />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="File/Case #" id="pt_nagencyreference" value={this.state.pt_nagencyreference} onChange={this.onChangeField} maxLength={50} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nagencyreference")} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Complainant First Name" id="pt_nunioncontactfirstname" value={this.state.pt_nunioncontactfirstname} onChange={this.onChangeField} maxLength={25} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nunioncontactfirstname")}
                                            required={
                                                (
                                                    this.state.pt_nunioncontactfirstname?.length > 0 ||
                                                    this.state.pt_nunioncontactlastname?.length > 0
                                                )} />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Complainant Last Name" id="pt_nunioncontactlastname" value={this.state.pt_nunioncontactlastname} onChange={this.onChangeField} maxLength={25} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nunioncontactlastname")}
                                            required={
                                                (
                                                    this.state.pt_nunioncontactfirstname?.length > 0 ||
                                                    this.state.pt_nunioncontactlastname?.length > 0
                                                )} />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Additional Complainant(s)" id="pt_nadditionalcomplainants" value={this.state.pt_nadditionalcomplainants} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nadditionalcomplainants")} />
                                    </StackItem>
                                </Stack>
                                <StackItem>
                                    <Stack horizontal wrap tokens={wrapTokens}>
                                        <StackItem grow>
                                            <TextField id="pt_noticeunionphone" alt="phonemask" value={this.state.pt_noticeunionphone} label="Phone Number" onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeunionphone")} required={
                                                (
                                                    this.state.pt_nunioncontactfirstname?.length > 0 ||
                                                    this.state.pt_nunioncontactlastname?.length > 0
                                                )} />
                                        </StackItem>
                                        <StackItem grow>
                                            <TextField label="Ext" id="pt_ncomplainantphoneext" value={this.state.pt_ncomplainantphoneext} onChange={this.onChangeField} maxLength={10} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_ncomplainantphoneext")} />
                                        </StackItem>
                                    </Stack>
                                </StackItem>
                                <StackItem>
                                    <Stack horizontal wrap tokens={wrapTokens}>
                                        <StackItem grow>
                                            <TextField label="Business Email" id="pt_noticeunionemail" value={this.state.pt_noticeunionemail} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeunionemail")} required={
                                                (
                                                    this.state.pt_nunioncontactfirstname?.length > 0 ||
                                                    this.state.pt_nunioncontactlastname?.length > 0
                                                )} />
                                        </StackItem>
                                        <StackItem grow>
                                            <TextField label="Confirm Email" id="pt_noticeunionemail_confirm" value={this.state.pt_noticeunionemail_confirm} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeunionemail_confirm")} required={
                                                (
                                                    this.state.pt_nunioncontactfirstname?.length > 0 ||
                                                    this.state.pt_nunioncontactlastname?.length > 0
                                                )} />
                                        </StackItem>
                                    </Stack>
                                </StackItem>
                            </StackItem>
                        </Stack>
                        <Separator alignContent="start"></Separator>
                        <Text variant={"xLarge" as ITextProps['variant']}>Location of Requested Services</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="City" id="pt_noticenegotiationcity" value={this.state.pt_noticenegotiationcity} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticenegotiationcity")} />
                                    </StackItem>
                                    <StackItem grow>
                                        <Label>State <span style={{ color: "rgb(164, 38, 44)" }}>*</span></Label>
                                        <TagPicker itemLimit={1} selectedItems={this.state.pt_noticenegotiationstate_selectedItems} styles={{ input: this.getErrorMessage(this.state.errorMessages, "pt_noticenegotiationstate").length > 0 ? { borderColor: "rgb(164, 38, 44)", border: "solid 1px" } : {} }}
                                            removeButtonAriaLabel="Remove"
                                            pickerCalloutProps={{ doNotLayer: true }} //keep this for accessibility
                                            onResolveSuggestions={this.onResolveSuggestionsState}
                                            onChange={(items?: ITag[] | undefined) => { this.onChangeTagPickerState("pt_noticenegotiationstate", items, true) }}
                                            onRenderSuggestionsItem={this.onRenderSuggestionsItemState}
                                            getTextFromItem={(item: ITag) => item.name}
                                            pickerSuggestionsProps={{ suggestionsHeaderText: 'Suggested States', noResultsFoundText: 'No states found' }}
                                            inputProps={{
                                                'aria-label': 'Type state or abbreviation',
                                                placeholder: 'Type state or abbreviation',
                                                autoComplete: "none"
                                            }}
                                        />
                                        <div role="alert" className="errorMessage" style={{ color: "rgb(164, 38, 44)", fontSize: "12px", height: "23px", lineHeight: "18px", paddingTop: "5px", display: this.getErrorMessage(this.state.errorMessages, "pt_noticenegotiationstate").length > 0 ? "block" : "none" }}>{this.getErrorMessage(this.state.errorMessages, "pt_noticenegotiationstate")}</div>
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Zip Code" alt="zipmask" id="pt_noticenegotiationzip" value={this.state.pt_noticenegotiationzip} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticenegotiationzip")} required />
                                    </StackItem>
                                </Stack>
                                <Stack>
                                    <StackItem shrink>
                                        <Dropdown id="pt_nhowtomeet" selectedKey={this.state.pt_nhowtomeet} label="How would you like to meet?" options={this.renderDropdownOption("key", "value", this.state.howToMeets)} onChange={this.onChangeDropdown} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nhowtomeet")} required />
                                    </StackItem>
                                    <StackItem>
                                        <div></div>
                                    </StackItem>
                                    <StackItem>
                                        <div></div>
                                    </StackItem>
                                </Stack>
                            </StackItem>
                        </Stack>
                        <Separator alignContent="start"></Separator>
                        <Text variant={"xLarge" as ITextProps['variant']}>Counsel/Rep</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Counsel/Rep First Name" id="pt_ncounselrepfirstname" value={this.state.pt_ncounselrepfirstname} onChange={this.onChangeField} maxLength={25} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_ncounselrepfirstname")} required={this.state.pt_ncounselrepfirstname?.length > 0 || this.state.pt_ncounselrepfirstname?.length > 0} />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Counsel/Rep Last Name" id="pt_ncounselreplastname" value={this.state.pt_ncounselreplastname} onChange={this.onChangeField} maxLength={25} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_ncounselreplastname")} required={this.state.pt_ncounselrepfirstname?.length > 0 || this.state.pt_ncounselrepfirstname?.length > 0} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                        </Stack>
                        <StackItem>
                            <Stack horizontal wrap tokens={wrapTokens}>
                                <StackItem grow>
                                    <TextField id="pt_ncounselrepphone" alt="phonemask" value={this.state.pt_ncounselrepphone} label="Phone Number" onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_ncounselrepphone")} required={this.state.pt_ncounselrepfirstname?.length > 0 || this.state.pt_ncounselrepfirstname?.length > 0} />
                                </StackItem>
                                <StackItem grow>
                                    <TextField label="Ext" id="pt_ncounselrepphoneext" value={this.state.pt_ncounselrepphoneext} onChange={this.onChangeField} maxLength={10} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_ncounselrepphoneext")} />
                                </StackItem>
                            </Stack>
                        </StackItem>
                        <StackItem>
                            <Stack horizontal wrap tokens={wrapTokens}>
                                <StackItem grow>
                                    <TextField label="Business Email" id="pt_ncounselrepemail" value={this.state.pt_ncounselrepemail} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_ncounselrepemail")} required={this.state.pt_ncounselrepfirstname?.length > 0 || this.state.pt_ncounselrepfirstname?.length > 0} />
                                </StackItem>
                                <StackItem grow>
                                    <TextField label="Confirm Email" id="pt_ncounselrepemail_confirm" value={this.state.pt_ncounselrepemail_confirm} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_ncounselrepemail_confirm")} required={this.state.pt_ncounselrepfirstname?.length > 0 || this.state.pt_ncounselrepfirstname?.length > 0} />
                                </StackItem>
                            </Stack>
                        </StackItem>
                    </div>
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Text variant={"xLarge" as ITextProps['variant']}>Respondent Information</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem grow>
                                <TextField label="Respondent" id="pt_nrespondentname" value={this.state.pt_nrespondentname} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nrespondentname")} />
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Contact First Name" id="pt_nrespondentcontactfirstname" value={this.state.pt_nrespondentcontactfirstname} onChange={this.onChangeField} maxLength={25} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nrespondentcontactfirstname")} required={this.state.pt_nrespondentname?.length > 0} />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Contact Last Name" id="pt_nrespondentcontactlastname" value={this.state.pt_nrespondentcontactlastname} onChange={this.onChangeField} maxLength={25} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nrespondentcontactlastname")} required={this.state.pt_nrespondentname?.length > 0} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Phone Number" alt="phonemask" id="pt_nrespondentphone" value={this.state.pt_nrespondentphone} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nrespondentphone")} required={this.state.pt_nrespondentname?.length > 0} />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Ext" id="pt_nrespondentext" value={this.state.pt_nrespondentext} onChange={this.onChangeField} maxLength={10} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nrespondentext")} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Business Email" id="pt_nrespondentemail" value={this.state.pt_nrespondentemail} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nrespondentemail")} required={this.state.pt_nrespondentname?.length > 0} />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Confirm Email" id="pt_nrespondentemail_confirm" value={this.state.pt_nrespondentemail_confirm} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nrespondentemail_confirm")} required={this.state.pt_nrespondentname?.length > 0} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem grow>
                                <TextField label="Notes" id="pt_nremarks" value={this.state.pt_nremarks} onChange={this.onChangeField} maxLength={1000} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nremarks")} multiline rows={3} />
                            </StackItem>
                        </Stack>
                    </div>
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Stack horizontal wrap tokens={wrapTokens}>
                            <StackItem grow>
                                <Label>Preferred Mediator (subject to availability)</Label>
                                <TagPicker itemLimit={1} selectedItems={this.state.pt_nrequestpreferredmediator_selectedItems}
                                    removeButtonAriaLabel="Remove"
                                    pickerCalloutProps={{ doNotLayer: true }} //keep this for accessibility
                                    onResolveSuggestions={this.onResolveSuggestionsHeardFromMediator}
                                    onChange={(items?: ITag[] | undefined) => { this.onChangeTagPickerMediator("pt_nrequestpreferredmediator", items) }}
                                    onRenderSuggestionsItem={this.onRenderSuggestionsItemMediator}
                                    getTextFromItem={(item: ITag) => item.name}
                                    pickerSuggestionsProps={{ suggestionsHeaderText: 'Suggested Mediators', noResultsFoundText: 'No Mediators found' }}
                                    inputProps={{
                                        'aria-label': 'Type to select your Preferred Mediator',
                                        placeholder: 'Type to select your Preferred Mediator',
                                        autoComplete: 'none'
                                    }}
                                />
                            </StackItem>
                        </Stack>
                    </div>
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Label>Additional Contact Email Addresses to Inform of Mediator Assignment (not listed above)</Label>
                        <Stack>
                            <StackItem>
                                <Label> </Label>
                            </StackItem>
                        </Stack>
                        <Stack>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField id="additionalEmail1" value={this.state.additionalEmail1} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "additionalEmail1")} maxLength={75} />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField id="additionalEmail2" value={this.state.additionalEmail2} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "additionalEmail2")} maxLength={75} />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField id="additionalEmail3" value={this.state.additionalEmail3} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "additionalEmail3")} maxLength={75} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                        </Stack>
                        <Stack>
                            <StackItem>
                                <Label> </Label>
                            </StackItem>
                        </Stack>
                        <Stack>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField id="additionalEmail4" value={this.state.additionalEmail4} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "additionalEmail4")} maxLength={75} />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField id="additionalEmail5" value={this.state.additionalEmail5} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "additionalEmail5")} maxLength={75} />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField id="additionalEmail6" value={this.state.additionalEmail6} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "additionalEmail6")} maxLength={75} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                        </Stack>
                        <Stack>
                            <StackItem>
                                <Label> </Label>
                            </StackItem>
                        </Stack>
                        <Stack>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField id="additionalEmail7" value={this.state.additionalEmail7} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "additionalEmail7")} maxLength={75} />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField id="additionalEmail8" value={this.state.additionalEmail8} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "additionalEmail8")} maxLength={75} />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField id="additionalEmail9" value={this.state.additionalEmail9} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "additionalEmail9")} maxLength={75} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                        </Stack>
                    </div>
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Text variant={"xLarge" as ITextProps['variant']}>Attach Document(s)</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                <p>
                                    Upload optional documents for this Referral.
                                </p>
                                <p>
                                    PDF only; max file size: 5 MB; max attachments: 9 documents.
                                </p>
                            </StackItem>
                        </Stack>
                        <Stack>
                            <StackItem>
                                <CommandBar items={documentUploadCommandBarItems} />
                            </StackItem>
                            <StackItem>
                                <DetailsList
                                    items={this.state.documents}
                                    columns={_documentColumns}
                                    setKey="recordIndex"
                                    layoutMode={DetailsListLayoutMode.justified}
                                    selection={this.documentSelection}
                                    selectionMode={SelectionMode.single}
                                    selectionPreservedOnEmptyClick={false}
                                    onRenderItemColumn={this.renderItemColumn}
                                    ariaLabelForSelectionColumn="Toggle selection"
                                    ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                    checkButtonAriaLabel="select row"
                                    onItemInvoked={this._onItemInvoked}
                                    onRenderDetailsHeader={(headerProps, defaultRender) => {
                                        return defaultRender({
                                            ...headerProps,
                                            styles: {
                                                root: {
                                                    selectors: {
                                                        '.ms-DetailsHeader-cell': {
                                                            whiteSpace: 'normal',
                                                            textOverflow: 'clip',
                                                            lineHeight: 'normal',
                                                        },
                                                        '.ms-DetailsHeader-cellTitle': {
                                                            height: '100%',
                                                            alignItems: 'center',
                                                        },
                                                    },
                                                }
                                            }
                                        })
                                    }}
                                />
                            </StackItem>
                        </Stack>
                    </div>
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Text variant={"xLarge" as ITextProps['variant']}>Filer Information</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="First Name" id="pt_nfilerfirstname" value={this.state.pt_nfilerfirstname} disabled />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Last Name" id="pt_nfilerlastname" value={this.state.pt_nfilerlastname} disabled />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Title" id="pt_nfilertitle" value={this.state.pt_nfilertitle} disabled />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Business Email" id="pt_nfileremail" value={this.state.pt_nfileremail} disabled />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Primary Phone" id="pt_nfilerphone" value={this.state.pt_nfilerphone} disabled />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Ext." id="pt_nfilerphoneext" value={this.state.pt_nfilerphoneext} disabled />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                        </Stack>
                    </div>
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Text variant={"xLarge" as ITextProps['variant']}>{<div className="content" dangerouslySetInnerHTML={{ __html: this.state.pt_footertitle }}></div>}</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                {<div className="content" dangerouslySetInnerHTML={{ __html: this.state.pt_footer }}></div>}
                            </StackItem>
                        </Stack>
                    </div>
                    <Stack>
                        <StackItem>
                            <PrimaryButton text="Submit Referral" onClick={this.onSubmitForm} allowDisabledFocus />
                        </StackItem>
                    </Stack>
                    <StackItem>
                        &nbsp;
                    </StackItem>
                    <StackItem>
                        <sub>Privacy Act Statement. 29 U.S.C. § 172, et seq., authorize the FMCS to require the reporting of this information. The primary use of the information on this form is to allow FMCS officials to provide mediation services. Additional disclosures of the information on this report may be made: (1) to a Federal, State, or local law enforcement agency if FMCS becomes aware of a violation or potential violation of law or regulation; (2) to a court or party in a court or Federal administrative proceeding if the Government is a party or in order to comply with a judge-issued subpoena; (3) to the National Archives and Records Administration or the General Services Administration in record management inspections; (4) to the Office of Management and Budget during legislative coordination on private relief legislation; and (5) in a judicial or administrative proceeding if the information is relevant to the subject matter.(6) This information may be used by FMCS to contact parties concerning trainings, events, presentations, conferences, and other education opportunities and programs. This information will not be disclosed to any requesting person unless authorized by law. Failure to provide the requested information could result in FMCS’s delay or inability to provide services.</sub>
                    </StackItem>
                </StackItem>
                <StackItem>
                    <div style={{ display: this.state.formState == CommonModels.FormState.OnLoad ? "block" : "none", boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Separator alignContent="start"></Separator>
                        <div>
                            <Spinner label="Loading..." ariaLive="assertive" labelPosition="top" size={SpinnerSize.large} />
                        </div>
                    </div>

                    <div style={{ display: this.state.formState == CommonModels.FormState.OnSave ? "block" : "none", boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Separator alignContent="start"></Separator>
                        <div>
                            <Spinner label="Saving..." ariaLive="assertive" labelPosition="top" size={SpinnerSize.large} />
                        </div>
                    </div>

                    <div style={{ display: this.state.formState == CommonModels.FormState.SaveComplete ? "block" : "none", boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Text variant={"xLarge" as ITextProps['variant']}>Confirmation</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                <p>Successful submission. Your Confirmation Number is <strong>{this.state.referralrecord?.pt_ConfirmationNoticeNumber}</strong></p>
                                <p>* Please do not re-submit this notice by U.S.mail or fax.</p>
                            </StackItem>
                            <StackItem>
                                <Link onClick={this.resetFormData}>Click here</Link> to submit another referral.
                            </StackItem>
                        </Stack>
                    </div>
                    <Dialog
                        hidden={this.state.dialogHidden}
                        onDismiss={e => this.setState({ dialogHidden: true })}
                        maxWidth={'600px'}
                        dialogContentProps={{
                            type: DialogType.normal,
                            title: 'Validation Error',
                            subText: 'Review the errors below and correct form fields as needed.',
                        }}
                        modalProps={{
                            isBlocking: true, styles: { main: {} }, dragOptions: {
                                moveMenuItemText: 'Move',
                                closeMenuItemText: 'Close',
                                menu: ContextualMenu,
                            }
                        }}>
                        <ul>
                            {this.state.errorMessages.map((item: any, index: number) => {
                                return <li>{(item.value as Array<string>).join(". ")}</li>
                            })}
                        </ul>
                        <DialogFooter>
                            <PrimaryButton onClick={e => this.setState({ dialogHidden: true })} text="Close" />
                        </DialogFooter>
                    </Dialog>
                    <Dialog
                        hidden={this.state.dialogResetHidden}
                        onDismiss={e => this.setState({ dialogHidden: true })}
                        dialogContentProps={{
                            type: DialogType.normal,
                            title: 'Reset Form',
                            subText: 'Would you like to reset the data on this form?',
                        }}
                        modalProps={{
                            isBlocking: true, styles: { main: {} }, dragOptions: {
                                moveMenuItemText: 'Move',
                                closeMenuItemText: 'Cancel',
                                menu: ContextualMenu,
                            }
                        }}>
                        <DialogFooter>
                            <PrimaryButton onClick={this.resetFormData} text="OK" />
                            <DefaultButton onClick={e => this.setState({ dialogResetHidden: true })} text="Cancel" />
                        </DialogFooter>
                    </Dialog>

                    <Dialog
                        hidden={this.state.cloneModalHidden}
                        onDismiss={e => this.setState({ cloneModalHidden: true })}
                        dialogContentProps={{
                            type: DialogType.normal,
                            title: 'Populate with Record',
                            subText: 'To populate the form using one of your previous submissions below select a record below and click OK.'
                        }}
                        minWidth="80%"
                        modalProps={{
                            isBlocking: true, styles: { main: {} }, dragOptions: {
                                moveMenuItemText: 'Move',
                                closeMenuItemText: 'Close',
                                menu: ContextualMenu,
                            }
                        }}>
                        <Stack horizontal>
                            <StackItem shrink>
                                <Dropdown styles={{ root: { display: this.state.cloneModalLoading == true ? "none" : "" } }} selectedKey={this.state.referralFilter} options={this.renderDropdownOption("value", "key", this.state.filters)} onChange={this.onChangeFilterDropdown} />
                            </StackItem>
                            <StackItem grow>
                                <Text variant={"large" as ITextProps['variant']}>    </Text>
                            </StackItem>
                            <StackItem align="end">
                                <PrimaryButton styles={{ root: { display: this.state.cloneModalLoading == true ? "none" : "", marginRight: "8px" } }} disabled={this.state.selectionCount == 0} onClick={e => this.setState({ cloneModalLoading: true }, () => this.copyRecord(this.state.selection))} text="OK" />
                                <PrimaryButton styles={{ root: { display: this.state.cloneModalLoading == true ? "none" : "" } }} onClick={e => this.setState({ cloneModalHidden: true })} text="Close" />
                            </StackItem>
                        </Stack>
                        <Stack>
                            <StackItem style={{ display: this.state.cloneModalLoading == false ? "block" : "none" }}>
                                <DetailsList
                                    items={this.state.referrals}
                                    columns={_columns}
                                    setKey="set"
                                    layoutMode={DetailsListLayoutMode.justified}
                                    selection={this.cloneSelection}
                                    selectionMode={SelectionMode.single}
                                    selectionPreservedOnEmptyClick={true}
                                    onRenderItemColumn={this.cloneRenderItemColumn}
                                    ariaLabelForSelectionColumn="Toggle selection"
                                    ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                    checkButtonAriaLabel="select row"
                                //onItemInvoked={this._onItemInvoked}
                                />
                            </StackItem>
                            <StackItem style={{ display: this.state.cloneModalLoading == false ? "none" : "block" }}>
                                <div>
                                    <Spinner label="Loading..." ariaLive="assertive" labelPosition="top" size={SpinnerSize.large} />
                                </div>
                            </StackItem>
                        </Stack>
                        <DialogFooter>
                            <PrimaryButton styles={{ root: { display: this.state.cloneModalLoading == true ? "none" : "" } }} disabled={this.state.selectionCount == 0} onClick={e => this.setState({ cloneModalLoading: true }, () => this.copyRecord(this.state.selection))} text="OK" />
                            <PrimaryButton styles={{ root: { display: this.state.cloneModalLoading == true ? "none" : "" } }} onClick={e => this.setState({ cloneModalHidden: true })} text="Close" />
                        </DialogFooter>
                    </Dialog>

                    <Dialog
                        hidden={this.state.uploadDocumentModalHidden}
                        onDismiss={this.fileUploadDismissed}
                        dialogContentProps={{
                            type: DialogType.normal,
                            title: 'Upload Document',
                            subText: 'Upload a PDF document with a max file size of 5 MB and select the type. '
                        }}
                        minWidth="40%"
                        modalProps={{
                            isBlocking: true, styles: { main: {} }, dragOptions: {
                                moveMenuItemText: 'Move',
                                closeMenuItemText: 'Close',
                                menu: ContextualMenu,
                            }
                        }}>
                        <Stack>
                            <StackItem>
                                <div style={{ marginBottom: "15px" }}>
                                    <Label required htmlFor="fileupload">Select a Document</Label>
                                    <input id="fileupload" type="file" name="file" onChange={this.onUploadDocument} accept="application/pdf" required />
                                </div>
                                <div>
                                    <label style={{ color: "rgb(164, 38, 44)" }}>{this.state.invalidFileUpload}</label>
                                </div>
                            </StackItem>
                            <StackItem>
                                <div style={{ marginBottom: "10px" }}>
                                    <Dropdown id="pt_documenttypeId" label="Select the Document Type" selectedKey={this.state.pt_documenttypeId} onChange={this.onChangeDropdown} options={this.renderDropdownOption("key", "value", this.state.documentTypes)} required />
                                </div>
                            </StackItem>
                            <StackItem>
                                <div>
                                    <label style={{ color: "rgb(164, 38, 44)" }}>{this.state.documentRequired}</label>
                                </div>
                                <div>
                                    <label style={{ color: "rgb(164, 38, 44)" }}>{this.state.documentTypeRequired}</label>
                                </div>
                            </StackItem>
                        </Stack>
                        <DialogFooter>
                            <PrimaryButton styles={{ root: { display: this.state.uploadDocumentModalHidden == true ? "none" : "" } }} onClick={this.addDocumentForUpload} text="Upload" />
                            <PrimaryButton styles={{ root: { display: this.state.uploadDocumentModalHidden == true ? "none" : "" } }} onClick={this.fileUploadCloseClick} text="Close" />
                        </DialogFooter>
                    </Dialog>
                </StackItem>

                <StackItem>
                    &nbsp;
                </StackItem>
                <StackItem>
                    <div style={{ boxShadow: theme.effects.elevation4, backgroundColor: "white", padding: "15px", marginBottom: "20px", display: this.state.user != undefined && this.state.user?.isReferral == true ? "block" : "none" }}>
                        <sub><p>Having issues with this page, please contact us for help at <a href="mailto:adrreferrals@fmcs.gov">adrreferrals@fmcs.gov</a>, or call (202) 606-5445.</p>
                        </sub>
                    </div>

                </StackItem>
            </Stack >

        )
    }
}